import React, { ComponentProps } from 'react';

import { Button } from 'antd';

type AntdButtonProps = ComponentProps<typeof Button>;

export const BaseButton = ({
  postIcon,
  ...props
}: AntdButtonProps & {
  postIcon?: React.ReactElement | null;
}) => (
  <>
    <Button {...props} className={`BaseButton ${props.className || ''}`}>
      {props.children}
      {postIcon}
    </Button>
    <style jsx global>{`
      .BaseButton svg + span {
        margin-left: 0.7em;
      }
      .BaseButton span + svg {
        margin-left: 0.7em;
      }
    `}</style>
  </>
);
